import React from "react";
import {
  UnitSizeIcon,
  BedIcon,
  BathIcon,
  MaidIcon,
} from "../../../../../../assets/icons";

export const MPITableHeaderData = (isDarkMode = false) => [
  {
    id: 1,
    formFieldId: 1,
    minWidth: 210,
    headerName: "Unit type",
    field: "unitType",
    sortable: true,
    filterable: true,
    fieldType: "text",
    displayPath: "unitType",
    isDefaultFilterColumn: true,
    fieldKey: "unitType",
    formFieldTitle: "Unit type",
    disableColumnMenu: true,
    searchKey: "unitType",
    renderCell: (item) => {
      return (
        <label
          style={{
            fontWeight: 400,
            color: !isDarkMode ? "#101828" : "#F5F5F6",
          }}
        >
          {item?.row?.unitType || "N/A"}
        </label>
      );
    },
  },
  {
    id: 2,
    formFieldId: 2,
    minWidth: 280,
    headerName: "Unit details",
    field: "unitDetails",
    sortable: true,
    filterable: true,
    fieldType: "text",
    displayPath: "unitDetails",
    isDefaultFilterColumn: true,
    fieldKey: "unitDetails",
    formFieldTitle: "Unit details",
    disableColumnMenu: true,
    searchKey: "unitDetails",
    renderCell: (item) => {
      const size = item.row?.size ? item.row.size.toLocaleString() : "—";
      const beds = item.row?.numberOfBedrooms ?? "—";
      const baths = item.row?.numberOfBathrooms ?? "—";
      const maids = item.row?.maidRoom ?? "—";
      return (
        <span style={{ display: "flex", alignItems: "center", gap: 2 }}>
          <UnitSizeIcon
            width="20"
            height="20"
            fill={!isDarkMode ? "#98A2B3" : "#85888E"}
            style={{ marginRight: 4 }}
          />
          <span style={{ color: !isDarkMode ? "#101828" : "#F5F5F6" }}>
            {size} sqft
          </span>
          <BedIcon
            width="20"
            height="20"
            fill={!isDarkMode ? "#98A2B3" : "#85888E"}
            style={{ margin: "0 4px 0 12px" }}
          />
          <span style={{ color: !isDarkMode ? "#101828" : "#F5F5F6" }}>
            {beds}
          </span>
          <BathIcon
            width="20"
            height="20"
            fill={!isDarkMode ? "#98A2B3" : "#85888E"}
            style={{ margin: "0 4px 0 12px" }}
          />
          <span style={{ color: !isDarkMode ? "#101828" : "#F5F5F6" }}>
            {baths}
          </span>
          <MaidIcon
            width="20"
            height="20"
            fill={!isDarkMode ? "#98A2B3" : "#85888E"}
            style={{ margin: "0 4px 0 12px" }}
          />
          <span style={{ color: !isDarkMode ? "#101828" : "#F5F5F6" }}>
            {maids}
          </span>
        </span>
      );
    },
  },
  {
    id: 3,
    formFieldId: 3,
    minWidth: 250,
    headerName: "Operation type",
    field: "operationType",
    sortable: true,
    filterable: true,
    fieldType: "text",
    displayPath: "operationType",
    isDefaultFilterColumn: true,
    fieldKey: "operationType",
    formFieldTitle: "Operation type",
    disableColumnMenu: true,
    searchKey: "operationType",
    renderCell: (item) => {
      const label =
        item?.row?.categoryIdentifier === 1
          ? "Lease"
          : item?.row?.categoryIdentifier === 2
          ? "Sale"
          : "N/A";
      return (
        <label
          style={{
            fontWeight: 400,
            color: !isDarkMode ? "#101828" : "#F5F5F6",
          }}
        >
          {label}
        </label>
      );
    },
  },
  {
    id: 4,
    formFieldId: 4,
    minWidth: 250,
    headerName: "Agency Name",
    field: "agencyName",
    sortable: true,
    filterable: true,
    fieldType: "text",
    displayPath: "agencyName",
    isDefaultFilterColumn: true,
    fieldKey: "agencyName",
    formFieldTitle: "Agency Name",
    disableColumnMenu: true,
    searchKey: "agencyName",
    renderCell: (item) => {
      return (
        <label
          style={{
            fontWeight: 400,
            color: !isDarkMode ? "#101828" : "#F5F5F6",
          }}
        >
          {item?.row?.agency || "N/A"}
        </label>
      );
    },
  },
  {
    id: 5,
    formFieldId: 5,
    minWidth: 250,
    headerName: "Market price",
    field: "marketPrice",
    sortable: true,
    filterable: true,
    fieldType: "text",
    displayPath: "marketPrice",
    isDefaultFilterColumn: true,
    fieldKey: "marketPrice",
    formFieldTitle: "Market price",
    disableColumnMenu: true,
    searchKey: "marketPrice",
    renderCell: (item) => {
      return (
        <label
          style={{
            fontWeight: 400,
            color: !isDarkMode ? "#344054" : "#CECFD2",
          }}
        >
          {item?.row?.marketPrice || "N/A"}
        </label>
      );
    },
  },
  {
    id: 6,
    formFieldId: 6,
    minWidth: 180,
    headerName: "Advertisment link",
    field: "advertismentLink",
    sortable: true,
    filterable: true,
    fieldType: "text",
    displayPath: "advertismentLink",
    isDefaultFilterColumn: true,
    fieldKey: "advertismentLink",
    formFieldTitle: "Advertisment link",
    disableColumnMenu: true,
    searchKey: "advertismentLink",
    renderCell: (item) => {
      const url = item?.row?.advertisementLink;
      return url ? (
        <a
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          style={{
            fontWeight: 400,
            color: !isDarkMode ? "#635235" : "#cecfd2",
            textDecoration: "none",
            cursor: "pointer",
          }}
        >
          Visit advertisement
        </a>
      ) : (
        <label
          style={{
            fontWeight: 400,
            color: !isDarkMode ? "#101828" : "#F5F5F6",
          }}
        >
          N/A
        </label>
      );
    },
  },
];
